module.exports = __webpack_public_path__ + "static/haela-symbol-DND3_FnP-1a7457539ab9c51b491f9afff416fef7.webp";